export const FITBIT_OAUTH2_PAGE_URL = 'https://www.fitbit.com/oauth2/authorize';
export const FITBIT_OAUTH2_API = 'https://api.fitbit.com/oauth2';
export const FITBIT_AUTH_SCOPES = ['sleep', 'profile'];
export const DOMAIN = 'SettingsScreen';
